import * as React from 'react';
import { useGetAdminUsers } from '@/__generated__/admin/admin';
import { DataTable, Column } from '@/features/pagination/components/DataTable';
import { usePagination } from '@/features/pagination/hooks/usePagination';
import { formatDate } from '@/utils/date';
import { AuthUser } from '@/__generated__/model/authUser';
import { Check, X } from 'lucide-react';
import { InviteAdminUserDialog } from './InviteAdminUserDialog';

export function ListAdminUsersPage() {
  const { page, perPage, handlePageChange } = usePagination();

  const { data, isLoading, mutate } = useGetAdminUsers({
    page,
    per_page: perPage,
  });

  const users = data?.auth_user ?? [];
  const hasNextPage = users.length === perPage;
  const hasPreviousPage = page > 1;

  const columns: Column<AuthUser>[] = [
    {
      header: 'ID',
      accessor: 'id',
    },
    {
      header: 'メールアドレス',
      accessor: 'email',
    },
    {
      header: 'メール認証',
      accessor: 'email_verified',
      cell: (row: AuthUser) => (
        <div className="flex items-center justify-center">
          {row.email_verified ? (
            <Check className="h-4 w-4 text-green-500" />
          ) : (
            <X className="h-4 w-4 text-red-500" />
          )}
        </div>
      ),
    },
    {
      header: '有効',
      accessor: 'disabled',
      cell: (row: AuthUser) => (
        <div className="flex items-center justify-center">
          {row.disabled ? (
            <X className="h-4 w-4 text-red-500" />
          ) : (
            <Check className="h-4 w-4 text-green-500" />
          )}
        </div>
      ),
    },
    {
      header: '最終ログイン',
      accessor: 'last_login_at',
      cell: (row: AuthUser) => formatDate(row.last_login_at),
    },
  ];

  return (
    <div className="space-y-6 px-6">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold text-gray-900">管理者ユーザー一覧</h1>
        <InviteAdminUserDialog onSuccess={mutate} />
      </div>
      <DataTable
        data={users}
        columns={columns}
        page={page}
        hasNextPage={hasNextPage}
        hasPreviousPage={hasPreviousPage}
        onPageChange={handlePageChange}
        isLoading={isLoading}
      />
    </div>
  );
}
